import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Building2, Users, Briefcase, CheckCircle } from 'lucide-react';
import { getSuperAdminDashboardApi } from '../../api/api';
import Card from '../../components/ui/Card.jsx';
import './SuperAdminDashboard.css';

export default function SuperAdminDashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getSuperAdminDashboardApi()
      .then((res) => {
        setDashboardData(res.data?.data || {});
      })
      .catch((err) => {
        setError('Failed to load dashboard data');
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="superadmin-dashboard-loading">
        <div className="spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="superadmin-dashboard-error">
        <p>{error}</p>
      </div>
    );
  }

  const stats = [
    {
      id: 'organizations',
      title: 'Total Organizations',
      value: dashboardData?.totalOrganizations || 0,
      icon: <Building2 size={24} />,
      color: '#667eea',
      link: '/superadmin/organizations',
    },
    {
      id: 'companies',
      title: 'Total Companies',
      value: dashboardData?.totalCompanies || 0,
      icon: <Briefcase size={24} />,
      color: '#48bb78',
      link: '/superadmin/organizations',
    },
    {
      id: 'users',
      title: 'Total Users',
      value: dashboardData?.totalUsers || 0,
      icon: <Users size={24} />,
      color: '#ed8936',
      link: '/superadmin/users',
    },
    {
      id: 'active',
      title: 'Active Organizations',
      value: dashboardData?.activeOrganizations || 0,
      icon: <CheckCircle size={24} />,
      color: '#38b2ac',
      link: '/superadmin/organizations',
    },
  ];

  return (
    <div className="superadmin-dashboard">
      <div className="superadmin-dashboard-header">
        <h1 className="superadmin-dashboard-title">Super Admin Dashboard</h1>
        <p className="superadmin-dashboard-subtitle">
          Manage organizations, companies, and users
        </p>
      </div>

      <div className="superadmin-dashboard-stats">
        {stats.map((stat) => (
          <Link
            key={stat.id}
            to={stat.link}
            className="superadmin-dashboard-stat-link"
          >
            <Card className="superadmin-dashboard-stat-card">
              <div
                className="superadmin-dashboard-stat-icon"
                style={{ backgroundColor: `${stat.color}15`, color: stat.color }}
              >
                {stat.icon}
              </div>
              <div className="superadmin-dashboard-stat-content">
                <h3 className="superadmin-dashboard-stat-value">{stat.value}</h3>
                <p className="superadmin-dashboard-stat-title">{stat.title}</p>
              </div>
            </Card>
          </Link>
        ))}
      </div>

      <div className="superadmin-dashboard-actions">
        <Link to="/superadmin/organizations" className="superadmin-dashboard-action-button">
          <Building2 size={20} />
          Manage Organizations
        </Link>
        <Link to="/superadmin/users" className="superadmin-dashboard-action-button">
          <Users size={20} />
          View All Users
        </Link>
      </div>
    </div>
  );
}

